import React, {useEffect, useState} from "react";
import SeasonController from "../../generated/controllers/seasonController";
import SeasonDisplay from "../../generated/interfaces/seasonDisplay";
import {dateFormat} from "../../date";

// Season picker for the yield-mass flow. Weights and processed maps are captured per season, so
// each of the yield dialogs needs an explicit season. Defaults to the farm's most recent season
// (the same one the server falls back to for a null seasonId) and reports the chosen id upward.
const SeasonSelect: React.FC<{
    farmId: number,
    value: number | null,
    onChange: (seasonId: number) => void
}> = ({farmId, value, onChange}) => {
    const [seasons, setSeasons] = useState<SeasonDisplay[]>([])

    useEffect(() => {
        SeasonController.farm({id: farmId}).then(resp => {
            const sorted = [...resp].sort((a, b) => new Date(b.start).getTime() - new Date(a.start).getTime())
            setSeasons(sorted)
            const latest = sorted[0]
            if (value == null && latest) onChange(latest.id)
        })
    }, [farmId])

    if (seasons.length === 0) return null

    return (
        <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500">Season</span>
            <select className="border rounded px-2 py-1"
                    value={value ?? ''}
                    onChange={e => onChange(Number(e.target.value))}>
                {seasons.map(s => (
                    <option key={s.id} value={s.id}>
                        {dateFormat(s.start, '%d %M %Y')} - {dateFormat(s.end, '%d %M %Y')}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default SeasonSelect
